<template lang="html">
  <div class="menusContainer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MobileMenuContainer'
}
</script>

<style lang="css" scoped>
.menusContainer {
  top:10%;
  margin-left: 25px;
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// MobileMenuContainer.vue?106d2aae